import React from 'react'
import { convertHtmlToNativeStyle } from '../../utils/htmlFormatter'

const HTML = (props) => {
    const textColor = props.color || "text-color"
    return <div className={`html-container ${textColor}`} dangerouslySetInnerHTML={{ __html: convertHtmlToNativeStyle(props.htmlContent) }} />
}

export default HTML;